import axios from 'axios'
import store from '@/xreports/store/index'
import { Message } from 'element-ui'
import { v4 as uuidv4 } from 'uuid'
import { getAppBaseConfig } from '@/storage/services/AppBaseConfigService'
import '@hotelcem/apis/interceptors/response/DetailQueryInterceptors'

class BaseAPI {
  constructor(config) {
    this.config = {
      baseURL: `${process.env.VUE_APP_APIBASEURL}/api/v1/`,
      timeout: 5000000,
      withCredentials: true,
      ...config,
    }
  }

  /**
   * custome error handle function
   */
  _handleError(error) {
    // 错误统一处理
    console.error(error)
    // 非200情况下
    let errorMessage = '网络异常，请稍后再试'
    /*
     * @Author: zhangxiaoyan
     * @Date: 2021-05-19 11:40
     * @Description: 接口超时错误提示
     */
    if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
      errorMessage = '查询失败，请刷新页面'
    }
    Message.error({
      message: errorMessage,
    })
  }

  /**
   * Request API method
   * @param {String} method
   * @param {String} url
   * @param {Object} rBody
   */
  async fetch(method, body) {
    const reqId = uuidv4().replace(/-/g, '')
    return axios({
      ...this.config,
      method,
      headers: {
        Authorization: getAppBaseConfig().appId,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        token: store.state.systemUser.token,
        ssoToken: store.state.systemUser.loginSsoToken || '',
        ContentType: 'application/json',
        reqId: reqId,
      },
      // include r_url, r_body
      ...body,
    })
      .then(res => {
        // HTTPCODE 始终是 200
        // 判断 code =? 200 或者 success =? true 来验证请求是否成功
        // if (!res || !res.data) {
        //   return Promise.reject(res || 'Empty HttpResponse')
        // }
        // const { code, successful, data } = res.data

        // if (successful) {
        //   return Promise.resolve(data)
        // }
        // if (['GENERAL_ERROR_ALERT'].includes(res.data?.msgcode)) {
        //   Message.error({ message: res.data?.message || res.data?.msg })
        // }
        // if (!res.data.msg) {
        //   res.data.msg = '请求出错，请联系管理员'
        // }
        // if (!res.data.message) {
        //   res.data.message = '请求出错，请联系管理员'
        // }

        // // 处理请求类型是blob
        // if (body.responseType && body.responseType === 'blob' && res.status === 200) {

        // }
        return Promise.resolve(res.data)
      })
      .catch(error => {
        if (error?.message !== 'CANCEL') {
          console.error(`response error: url=${body.url}; reqId = ${reqId}; `)
        }
        const data = error?.code || error?.response?.data || {}
        const status = error?.status

        if (['GENERAL_ERROR_ALERT'].includes(error?.msgcode)) {
          Message.error({ message: error.message || error.msg })
        }

        if (data.code === 401 || status === 401) {
          store.dispatch('systemUser/logout')
          return Promise.reject(error)
        } else {
          if (error.isAxiosError) {
            this._handleError(error)
            return Promise.reject(error)
          } else {
            return Promise.reject(error)
          }
        }
      })
  }

  /**
   * Fetch all requests used by axios.all
   * @param {Array} requests
   * @param {Function} callback 回调函数
   */
  async fetchAll(requests, callback) {
    return axios
      .all(requests)
      .then(axios.spread(callback))
      .catch(error => {
        this._handleError(error)
      })
  }

  async get(params = {}) {
    return this.fetch('GET', params)
  }

  async post(body = {}) {
    return this.fetch('POST', body)
  }

  async delete(params) {
    return this.fetch('DELETE', params)
  }
}

export default BaseAPI
